import { render, staticRenderFns } from "./ConfigurazioneDeviceAssociaOperatoreModalComponent.vue?vue&type=template&id=bc93fd86&scoped=true"
import script from "./ConfigurazioneDeviceAssociaOperatoreModalComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneDeviceAssociaOperatoreModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneDeviceAssociaOperatoreModalComponent.vue?vue&type=style&index=0&id=bc93fd86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc93fd86",
  null
  
)

export default component.exports